module.exports = __webpack_public_path__ + "static/media/Frame47.190676a2.svg";